<section class="max-w-full w-full h-full relative top-0 left-0 bg-wrapper">
  <div class="w-full h-full px-4 flex flex-col gap-8 text-center">
    <div class="py-16 flex items-center justify-end md:justify-center">
      <lang-translate-bar></lang-translate-bar>
    </div>
    <div class="w-full xl:pt-16 flex flex-col justify-start self-center items-center text-center max-w-2xl content">
      <div class="pb-6"><korviu-logo size="s" theme="white"></korviu-logo></div>
      <div class="flex flex-col justify-evenly items-center text pb-[2.5rem]">
        <h1 class="heading-xlarge lg:whitespace-nowrap outfit extra-bold p-0 m-0">
          {{ 'welcoming.welcomeToUnigana' | translate }}
        </h1>
        <h2 class="w-full max-w-[18rem] sm:max-w-none paragraph-large outfit font-medium sub-header">
          {{ 'welcoming.growYour' | translate }}
        </h2>
      </div>
      <div
        class="px-6 py-4 flex flex-row gap-4 items-center rounded-lg border-1 border-solid border-[#737980] card bg-[#FCFCFC] w-full max-w-[31rem] mb-4 md:mb-6 cursor-pointer"
        (click)="onSignUpClick()"
      >
        <div class="flex flex-col items-start flex-1">
          <div class="text-[1rem]/[160%] md:text-[1.125rem]/[160%] text-[#393E44] font-bold text-left">
            {{ 'auth.signUpEarnRewards' | translate }}
          </div>
          <div class="text-[0.8125rem]/[160%] md:text-[1.125rem]/[160%] text-[#505760] text-left">
            {{ 'auth.joinTheUniGanaCommunity' | translate }}
          </div>
        </div>
        <div class="size-[3.5rem] md:size-[5.5rem]">
          <img class="size-full" src="assets/img/members-type.svg" alt="" />
        </div>
      </div>
      <div
        class="px-6 py-4 flex flex-row gap-4 items-center rounded-lg border-1 border-solid border-[#737980] card bg-[#FCFCFC] w-full max-w-[31rem] cursor-pointer mb-8"
        (click)="onPartnerApplicationClick()"
      >
        <div class="flex flex-col items-start flex-1">
          <div class="text-[1rem]/[160%] md:text-[1.125rem]/[160%] text-[#393E44] font-bold text-left">
            {{ 'auth.applyBecomePartner' | translate }}
          </div>
          <div class="text-[0.8125rem]/[160%] md:text-[1.125rem]/[160%] text-[#505760] text-left">
            {{ 'auth.helpShareUniGanaOkeeyCash' | translate }}
          </div>
        </div>
        <div class="size-[3.5rem] md:size-[5.5rem]">
          <img class="size-full" src="assets/img/partner-type.svg" alt="" />
        </div>
      </div>
      <span class="paragraph-medium light flex gap-2">
        {{ 'auth.login.alreadyHave' | translate }}
        <a routerLink="/auth/log-in" class="paragraph-medium light sign-up">
          {{ 'auth.signinButton' | translate }}
        </a>
      </span>
    </div>
  </div>
  <div class="absolute w-full bottom-0"><unigana-footer></unigana-footer></div>
</section>
